// Types
import { RootState } from 'types/RootState.types';

// Config
import featureConstants, { DISABLED_FEATURE } from '@constants/featureConstants';
import { isFeatureActive, isFeatureDisabled } from '@redux/reducers/config/configReducer';

const isPayPalAvailable = (state: RootState) => {
  const isDisabled =
    isFeatureDisabled(state, DISABLED_FEATURE.PAYPAL) || isFeatureActive(state, featureConstants.DISABLE_PAYPAL);

  return !isDisabled;
};

export default isPayPalAvailable;
